export default function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/utils/getMainAxisFromPlacement.js
// module id = 406
// module chunks = 22